import React, { FC } from 'react'
import { planPrice } from 'common/utils/planPrice'
import { PlanSlug } from 'common/planSlugs'
import Icon from 'components/Icon'
import Card from './base/Card'

type Row = {
  feature: string
  otherProviders: string
  theHoxtonMix: string
}

const data: Row[] = [
  {
    feature: 'AI-Powered Mail Companion',
    otherProviders: 'Not offered – no AI automation, manual sorting.',
    theHoxtonMix: 'Yes – HaiRo™ sorts, digitises & organises your post.',
  },
  {
    feature: 'Free Digital Mail Scanning',
    otherProviders: 'Often extra fees.',
    theHoxtonMix: 'Yes – no extra costs.',
  },
  {
    feature: 'Cancel Anytime',
    otherProviders: 'Often tied into contracts.',
    theHoxtonMix: 'Yes – no lock-in, rolling plans.',
  },
  {
    feature: 'Customer Portal & Mobile Apps',
    otherProviders: 'Limited or no app access.',
    theHoxtonMix: 'Full access on iOS, Android & Web.',
  },
  {
    feature: 'No Setup / Hidden Fees',
    otherProviders: 'Unexpected costs & handling fees.',
    theHoxtonMix: 'No setup costs, no hidden fees.',
  },
  {
    feature: 'Mail Processed Within 1 Business Day',
    otherProviders: 'Processing limited to a few days a week.',
    theHoxtonMix: 'Yes – next-day digital delivery.',
  },
  {
    feature: 'In-House Enterprise Postroom',
    otherProviders: 'Limited scalability.',
    theHoxtonMix: 'High-volume mail processing.',
  },
  {
    feature: 'Secure Mail Handling & Storage',
    otherProviders: 'Lacks enterprise-level security.',
    theHoxtonMix: 'Fully encrypted, Cyber Essentials Plus certified.',
  },
]

const CompareTable: FC = () => (
  <div>
    <Card className='bg-white pt-5 overflow-hidden' shadow>
      <div className='text-center d-block d-md-none mb-4'>
        <div className='fs-32 fw-semibold'>Hoxton Mix</div>
        <div className='fw-semibold'>
          <strong>{planPrice.monthlyOnYearlyPlan(PlanSlug.SCAN_LITE)}</strong> –
          Affordable, simple pricing.
        </div>
      </div>
      <table className='zebra'>
        <thead>
          <tr>
            <th></th>
            <th>
              <div className='text-center bg-grey8 pb-lg-3 pt-lg-1 rounded-top'>
                <div className='fs-fluid-14-32 '>Hoxton Mix</div>
                <div className='d-none d-md-block fw-semibold'>
                  <strong>
                    {planPrice.monthlyOnYearlyPlan(PlanSlug.SCAN_LITE)}
                  </strong>{' '}
                  – Affordable, simple pricing.
                </div>
              </div>
            </th>
            <th>
              <div className='text-center fw-semibold'>
                <div className='fs-fluid-11-24'>Other Providers</div>
                <div className='fs-16 d-none d-md-block'>
                  Often <strong>£40</strong>+ – Overpriced, fewer features.
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map(({ feature, otherProviders, theHoxtonMix }, i) => (
            <tr key={feature}>
              <td className='p-5 fw-bold fs-fluid-12-20'>{feature}</td>
              <td className='p-5 fw-semibold bordered fs-fluid-12-20'>
                <div className='d-flex align-items-center justify-content-center justify-content-md-start gap-4 '>
                  <Icon name='tick-circle' fill='success' className='mr-1' />
                  <span
                    className='d-none d-lg-block'
                    dangerouslySetInnerHTML={{ __html: theHoxtonMix }}
                  />
                </div>
              </td>
              <td className='p-5 fw-semibold fs-fluid-12-20'>
                <div className='d-flex gap-4 justify-content-center justify-content-md-start align-items-center'>
                  <Icon
                    name='close-circle'
                    fill='danger'
                    fill2='white'
                    className='mr-1'
                  />
                  <span
                    className='d-none d-lg-block'
                    dangerouslySetInnerHTML={{ __html: otherProviders }}
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>

    <div className='text-center fw-semibold pt-5 pt-lg-5 fs-fluid-20-24'>
      With The Hoxton Mix, you get everything included in one simple plan.
      <div className='color-pink3'>No surprises. No hidden costs.</div>
    </div>
  </div>
)

export default CompareTable
